import { gql } from '@apollo/client';

/** 合包扫描专用查询：在基础信息之上额外返回 sortingRule、parcelCount、mergeableParcelCount */
export const GET_BAG_MERGE_SCAN_INFO_BY_NUMBER = gql`
  query GetBagMergeScanInfoByNumber($bagNumber: String!) {
    getBagMergeScanInfoByNumber(bagNumber: $bagNumber) {
      id
      bagNumber
      businessType
      sortingCode
      sortingRule
      parcelCount
      mergeableParcelCount
      status
      warehouseId
      printType
    }
  }
`;

export interface BagMergeScanInfoType {
  id: string;
  bagNumber: string;
  businessType: number | null;
  sortingCode: string | null;
  /** 分拣规则：from-nextStop-尾程商缩写 */
  sortingRule: string | null;
  /** 包裹数量（BOUND 且未删除） */
  parcelCount: number | null;
  /** 可合包包裹数（BOUND 且非 is_finished） */
  mergeableParcelCount: number | null;
  status: number;
  /** 创建站点ID */
  warehouseId: number | null;
  /** 打印模板类型(1-SwiftX、2-TT) */
  printType: number | null;
}

export interface GetBagMergeScanInfoByNumberResponse {
  getBagMergeScanInfoByNumber: BagMergeScanInfoType | null;
}
